import { useId, useRef, useState } from 'react';
import { toast } from 'sonner';
import { SendIcon } from 'lucide-react';
import { AutoTextarea } from '../ui/AutoTextarea';
import { btnSecondary, inputCls } from '../ui/styles';
import { addHandoffNote } from '../adminApi';
import { newRequestId } from '../../core/api/http';
import { errorMessage } from '../../core/errors';
const MAX_LENGTH = 1000;
type Props = {
  customerId: string;
  appointmentId?: string;
  /** Aan wie (de naam van de eigenaar). */
  to: string;
};

/**
 * Notitie van de collega aan Sarah, bij deze klant. Komt op Sarahs overzicht tot ze hem als
 * gelezen markeert. Intern: de klant ziet het nooit.
 */
export function HandoffNoteForm({
  customerId,
  appointmentId,
  to
}: Props) {
  const id = useId();
  const [text, setText] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const request = useRef(newRequestId());
  const send = async () => {
    if (!text.trim()) {
      setError('Schrijf eerst iets.');
      return;
    }
    setBusy(true);
    setError('');
    try {
      await addHandoffNote(customerId, {
        requestId: request.current,
        text: text.trim(),
        ...(appointmentId ? {
          appointmentId
        } : {})
      });
      request.current = newRequestId();
      setText('');
      toast.success(`Notitie naar ${to} gestuurd`);
    } catch (err) {
      setError(errorMessage(err) ?? 'Versturen lukte niet. Probeer het opnieuw.');
    } finally {
      setBusy(false);
    }
  };
  return <div data-id="element-1413" data-mp="2ogv3oumm6ygm">
      <label htmlFor={id} className="mb-1 block text-[13px] text-ink" data-id="element-1414" data-mp="2jk4solpo2t22">
        Notitie voor {to}
      </label>
      <AutoTextarea id={id} value={text} onChange={e => setText(e.target.value)} minRows={2} maxLength={MAX_LENGTH} placeholder="Bijv. reageerde wat rood op de peeling, volgende keer milder." className={inputCls} aria-describedby={error ? `${id}-err` : undefined} data-id="element-1415" data-mp="2y8r78l7gzgs8" />
      {error && <p id={`${id}-err`} role="alert" className="mt-1 text-[12px] text-clay" data-id="element-1416" data-mp="20tdaqvrm5uc2">
          {error}
        </p>}
      <button type="button" onClick={() => void send()} disabled={busy} aria-busy={busy} className={`${btnSecondary} mt-2`} data-id="element-1417" data-mp="2qfy3iptoiw2j">
        <SendIcon className="h-4 w-4" strokeWidth={1.75} aria-hidden="true" data-id="element-1418" data-mp="2z9kn7hkm48vd" />
        {busy ? 'Versturen…' : `Naar ${to}`}
      </button>
    </div>;
}